module.exports = __webpack_public_path__ + "static/img/clay-banks-vZB4YSHS9HE-unsplash_thumb.0ec0141.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/clay-banks-vZB4YSHS9HE-unsplash_thumb.png
// module id = m0Gl
// module chunks = 4